(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-video-spanish"]) return;
  try {
    
  var videos = document.querySelectorAll(".video");
  videos.forEach(function (video) {
    var videoPoster = video.querySelector(".video__poster");
    var videoElement = video.querySelector(".video__video");
    var iframe = video.querySelector("iframe");
  
    videoPoster.addEventListener("click", function () {
      videoPoster.classList.add("video__poster--hide"); 
  
      if (iframe) {
        iframe.style.display = "block"; // Show the iframe
        var iframeSrc = iframe.getAttribute("src");
        iframe.setAttribute("src", iframeSrc + "?autoplay=1&mute=1"); 
      } else if (videoElement) {
        videoElement.play();
      }
      
    
    });
  if (videoElement) {
        videoElement.addEventListener("ended", function () {
          videoPoster.classList.remove("video__poster--hide"); 
        });
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-video"] && !Shopify.designMode) return;
  try {
    
  var videos = document.querySelectorAll(".video");
  videos.forEach(function (video) {
    var videoPoster = video.querySelector(".video__poster");
    var videoElement = video.querySelector(".video__video");
    var iframe = video.querySelector("iframe");
  
    videoPoster.addEventListener("click", function () {
      videoPoster.classList.add("video__poster--hide"); 
  
      if (iframe) {
        iframe.style.display = "block"; // Show the iframe
        var iframeSrc = iframe.getAttribute("src");
        iframe.setAttribute("src", iframeSrc + "?autoplay=1&mute=1"); 
      } else if (videoElement) {
        videoElement.play();
      }
      
    
    });
  if (videoElement) {
        videoElement.addEventListener("ended", function () {
          videoPoster.classList.remove("video__poster--hide"); 
        });
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jre_tab_content"] && !Shopify.designMode) return;
  try {
    
$('.tab_name_list li').click(function() {
	// Remove active class from all items
	$(this).closest('.tab_name_list').find('li').removeClass('active');
	$(this).closest('.type_tab_content').find('.cat_space_item').removeClass('active');
	// Add active class to just this item(s)
	$(this).addClass('active');
	$('.nt_'+$(this).attr('data-block-id')).addClass('active');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jre_testimonials"] && !Shopify.designMode) return;
  try {
    
setTimeout(function() {
// Hide non-active testimonial containers 
$('.testimonials-container').removeClass('active');
// Show first testimonials container  
$('.testimonials-container').eq(0).addClass('active');
},5000);
// Toggle testimonial containers 
// $('.testimonial-group-names li').click(function() {
$('body').on('click', '.testimonial-group-names li', function(e) { 
  console.log('testimonial group name clicked');
	// Remove active class from all items
	$(this).closest('.testimonial-group-names').find('li').removeClass('active');
	$('div[data-testimonial-group-index]').removeClass('active');
	// Add active class to just this item(s)
	$(this).addClass('active');
	$('div[data-testimonial-group-index="'+$(this).attr('data-testimonial-group-target')+'"').addClass('active');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp_testimonials"] && !Shopify.designMode) return;
  try {
    
setTimeout(function() {
// Hide non-active testimonial containers 
$('.testimonials-container').removeClass('active');
// Show first testimonials container  
$('.testimonials-container').eq(0).addClass('active');
},5000);
// Toggle testimonial containers 
$('.testimonial-group-names li').click(function() {
  console.log('testimonial group name clicked');
	// Remove active class from all items
	$(this).closest('.testimonial-group-names').find('li').removeClass('active');
	$('div[data-testimonial-group-index]').removeClass('active');
	// Add active class to just this item(s)
	$(this).addClass('active');
	$('div[data-testimonial-group-index="'+$(this).attr('data-testimonial-group-target')+'"').addClass('active');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab_content-spanish"]) return;
  try {
    
$('.tab_name_list li').click(function() {
	// Remove active class from all items
	$(this).closest('.tab_name_list').find('li').removeClass('active');
	$(this).closest('.type_tab_content').find('.cat_space_item').removeClass('active');
	// Add active class to just this item(s)
	$(this).addClass('active');
	$('.nt_'+$(this).attr('data-block-id')).addClass('active');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab_content"] && !Shopify.designMode) return;
  try {
    
$('.tab_name_list li').click(function() {
	// Remove active class from all items
	$(this).closest('.tab_name_list').find('li').removeClass('active');
	$(this).closest('.type_tab_content').find('.cat_space_item').removeClass('active');
	// Add active class to just this item(s)
	$(this).addClass('active');
	$('.nt_'+$(this).attr('data-block-id')).addClass('active');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-spanish"]) return;
  try {
    
setTimeout(function() {
// Hide non-active testimonial containers 
$('.testimonials-container').removeClass('active');
// Show first testimonials container  
$('.testimonials-container').eq(0).addClass('active');
},5000);
// Toggle testimonial containers 
$('.testimonial-group-names li').click(function() {
  console.log('testimonial group name clicked');
	// Remove active class from all items
	$(this).closest('.testimonial-group-names').find('li').removeClass('active');
	$('div[data-testimonial-group-index]').removeClass('active');
	// Add active class to just this item(s)
	$(this).addClass('active');
	$('div[data-testimonial-group-index="'+$(this).attr('data-testimonial-group-target')+'"').addClass('active');

    var flkty = new Flickity('.testimonials-container.active');
    flkty.resize();
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
setTimeout(function() {
// Hide non-active testimonial containers 
$('.testimonials-container').removeClass('active');
// Show first testimonials container  
$('.testimonials-container').eq(0).addClass('active');
},5000);
// Toggle testimonial containers 
$('.testimonial-group-names li').click(function() {
  console.log('testimonial group name clicked');
	// Remove active class from all items
	$(this).closest('.testimonial-group-names').find('li').removeClass('active');
	$('div[data-testimonial-group-index]').removeClass('active');
	// Add active class to just this item(s)
	$(this).addClass('active');
	$('div[data-testimonial-group-index="'+$(this).attr('data-testimonial-group-target')+'"').addClass('active');

    var flkty = new Flickity('.testimonials-container.active');
    flkty.resize();
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["try-testinomials"] && !Shopify.designMode) return;
  try {
    
setTimeout(function() {
// Hide non-active testimonial containers 
$('.testimonials-container').removeClass('active');
// Show first testimonials container  
$('.testimonials-container').eq(0).addClass('active');
},5000);
// Toggle testimonial containers 
$('.testimonial-group-names li').click(function() {
  console.log('testimonial group name clicked');
	// Remove active class from all items
	$(this).closest('.testimonial-group-names').find('li').removeClass('active');
	$('div[data-testimonial-group-index]').removeClass('active');
	// Add active class to just this item(s)
	$(this).addClass('active');
	$('div[data-testimonial-group-index="'+$(this).attr('data-testimonial-group-target')+'"').addClass('active');
});

  } catch(e) { console.error(e); }
})();
})();
